import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import ScrollToTop from "scrolltotop.js"; // Used for scrolling to top of page when navigating between pages.

import Index_Page from "pages/index";
import History_Page from "pages/history";
import Projects_Page from "pages/projects";
import Team_Page from "pages/team";
import DataDashboard_Page from "pages/datadashboard";
import Page404 from "pages/page404new";

import Articles_Page from "subpages/articles";
import ArticleTemplate_Page from "subpages/_articles_template";

const GlobalStyles = createGlobalStyle`
    body {
        margin: 0;
        padding: 0;
        font-family: sans-serif;
    }
`;

export default () => (
  <Router>
    <GlobalStyles />
    <ScrollToTop />
    <Switch>
      <Route exact path="/" component={Index_Page} />
      <Route exact path="/index" component={Index_Page} />
      <Route exact path="/history" component={History_Page} />
      <Route exact path="/projects" component={Projects_Page} />
      <Route exact path="/articles" component={Articles_Page} />
      <Route exact path="/team" component={Team_Page} />
      <Route exact path="/datadashboard" component={DataDashboard_Page} />

      {/* Dynamic route for articles: */}
      <Route path="/articles/:articleId" component={ArticleTemplate_Page} />

      {/* This route needs to be listed last because this is the catch-all 404 route.*/}
      <Route component={Page404} />
    </Switch>
  </Router>
);
